import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { ArrowUp, Calendar, Dialog, Eye, Hit, Podcast, Twitter } from './../Icons';

const Icon = ({ icon = '', ...rest }) => {
  const icons = {
    'arrow-up': <ArrowUp {...rest} />,
    calendar: <Calendar {...rest} />,
    dialog: <Dialog {...rest} />,
    eye: <Eye {...rest} />,
    hit: <Hit {...rest} />,
    podcast: <Podcast {...rest} />,
    twitter: <Twitter {...rest} />,
  };

  return icons[icon] || null;
};

const Stat = ({ description, icon, number, title, unit }) => {
  return (
    <div className={classnames('stat', { [`stat--${icon}`]: icon })}>
      <div className='row g-0'>
        <div className='col'>
          <div className='stat__container'>
            <Icon icon={icon} className='stat__icon stat__icon--1' />
            <div className='stat__main'>
              {number && <div className='stat__number'>{number}</div>}
              {unit && <div className='stat__unit'>{unit}</div>}
              {(title || description) && (
                <div className='stat__secondary'>
                  {title && <div className='stat__title'>{title}</div>}
                  {description && <div className='stat__description'>{description}</div>}
                </div>
              )}
            </div>
            <Icon icon={icon} className='stat__icon stat__icon--2' />
          </div>
        </div>
      </div>
    </div>
  );
};

Icon.propTypes = {
  icon: PropTypes.string,
  rest: PropTypes.object,
};

Stat.propTypes = {
  description: PropTypes.string,
  icon: PropTypes.string,
  number: PropTypes.string,
  title: PropTypes.string,
  unit: PropTypes.string,
};

export default Stat;
